import React from 'react';
import { Popup, IdGen } from '@leverege/ui-elements';
import { UserSettings } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import HistoryViewModel from "../models/HistoryViewModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
const ids = IdGen.createIds('lItem', 3);
const {
  t,
  tfIcon
} = I18N.ns('molten.dataViewers.history.QueryDensityToggle');
export default {
  id: 'history.QueryDensityToggle',
  matches: {
    client: ['HistoryTableViewer', 'HistoryListViewer'],
    use: 'actionBar'
  },
  handles: () => true,
  layout: {
    group: ['Settings'],
    groupIcons: [tfIcon('settingsIcon', 'fa fa-cog fa-fw')]
  },
  customComponent: ({
    context
  }) => {
    const {
      clientProps
    } = context;
    const {
      model,
      settingsPath
    } = clientProps;
    const onChange = evt => {
      UserSettings.set(settingsPath, evt.value);
    };
    const onChangeDensity = evt => {
      const nModel = HistoryViewModel.setDensity(model, evt.value);
      onChange({
        value: nModel
      });
    };
    const density = HistoryViewModel.getDensity(model);
    return [/*#__PURE__*/_jsx(Popup.Header, {
      children: t('density')
    }, ids[0]), /*#__PURE__*/_jsx(Popup.Item, {
      value: "sparse",
      onClick: onChangeDensity,
      checked: density === 'sparse',
      checkStyle: "radio",
      children: t('sparse')
    }, ids[1]), /*#__PURE__*/_jsx(Popup.Item, {
      value: "dense",
      onClick: onChangeDensity,
      checked: density === 'dense',
      checkStyle: "radio",
      children: t('dense')
    }, ids[2])];
  }
};